import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=46a66dd2&scoped=true&"
import script from "./ErrorList.vue?vue&type=script&lang=ts&"
export * from "./ErrorList.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=46a66dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a66dd2",
  null
  
)

export default component.exports